document.addEventListener 'turbo:load', ->
  lazyVideos = [].slice.call(document.querySelectorAll('video[data-lazy]'))
  loadVideo = (video) ->
    for source of video.children
      videoSource = video.children[source] if video.children
      if typeof videoSource.tagName == 'string' and videoSource.tagName == 'SOURCE'
        videoSource.src = videoSource.dataset.src
        video.load()
      return

  if 'IntersectionObserver' of window
    lazyVideoObserver = new IntersectionObserver((entries, observer) ->
      entries.forEach (video) ->
        if video.isIntersecting
          loadVideo(video.target)
          lazyVideoObserver.unobserve video.target
        return
      return

    )
    lazyVideos.forEach (lazyVideo) ->
      lazyVideoObserver.observe lazyVideo
      return
  else
    lazyVideos.forEach (lazyVideo) ->
      loadVideo(lazyVideo)
      return
  return